import React, { useEffect, useState  } from 'react';
import { useSelector } from 'react-redux';
import Header from '@/views/components/Header/Header';
import { useNavigate, useLocation } from 'react-router';
import Footer from '@/views/components/Footer/Footer';
import QuestionShort from '@/views/components/SimpleTextAdivse/QuestionShort/QuestionShort';
import Pagination from '@/utils/pagination/Pagination';
import styles from '@/views/pages/SimpleTextMyAdvices/SimpleTextMyAdvices.module.scss';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ModalAddQuestion from '@/views/components/SimpleTextAdivse/Modals/ModalAddQuestion';
import { Link } from "react-router-dom";
import TopSection from '@/views/components/SimpleTextAdivse/TopSection/TopSection';
import api from '@/services/api';
import useWindowIsMobile from '@/utils/hooks/useWindowIsMobile';

const SimpleTextMyAdvices = () => {
	const [ questions, setQuestions ] = useState([]);
	const [ pages, setPages ] = useState(1);
	const [ tabs, setTabs ] = useState([]);
	const [ tabValue, setTabValue ] = useState(null);
	const [ tabCount, setTabCount ] = useState([]);
	const [ showModalAdd, setShowModalAdd ] = useState(false);

	const location = useLocation();
	const dict = useSelector(state => state.app.dict);
	const isMobile = useWindowIsMobile(768);
	const itemsPerPager = 20;

	const navigate = useNavigate();

	const { search: locationSearch, pathname } = location;

	const getNameForLabel = (name) => {
		switch (name) {
			case "advice-received":
				return `${dict.simpleTextAdvices.myAdvices.recived} (${tabCount[name] ? tabCount[name] : "0"})`;
			case "waiting":
				return `${dict.simpleTextAdvices.myAdvices.waiting} (${tabCount[name] ? tabCount[name] : "0"})`;
			default:
				return ""; 
		}
	};

	const getQuestions = async () => {
		const params = new URLSearchParams(locationSearch);

		if(!tabValue) {
			getTabs();
		} else {
			const {data} = await api.get(`/questions/my-questions?perpage=${itemsPerPager}&tabName=${tabValue}&${params}`);

			setPages(data.paginatedQuestions.pages);
			setQuestions(data.paginatedQuestions
				.questions);
			setTabCount(data.countedTabs);
		}
	};

	const getTabs = async () => {
		const {data} = await api.get(`/questions/editor-tabs`);
	
		const newTabs = Object.keys(data).map(key => ({
			id: parseInt(key),
			value: data[key], 
			label: getNameForLabel(data[key]),
		}));
		
		setTabs(newTabs);
		setTabValue(newTabs[0].value);
	};

	useEffect(() => {
		getQuestions();
	}, [ locationSearch, tabValue ]);

	useEffect(() => {
		const tabsNumber = tabs.map(tab => ({...tab, label: getNameForLabel(tab.value)}));
		setTabs(tabsNumber);
	}, [ tabCount ]);

	useEffect(() => {
		const params = new URLSearchParams(locationSearch);
		params.delete('page');
		navigate(`${pathname}?${params}`);
	}, [ tabValue ]);

	useEffect(() => {
		if(locationSearch.includes('question')) {
			setShowModalAdd(true);
			const url = pathname.replace('?question', '');
			navigate(url);
		}
	}, [ locationSearch ]);
	
	const handleChange = (event, newValue) => {
		setTabValue(newValue);
	};

	return (
		<>
			{showModalAdd && <ModalAddQuestion 
				getQuestions={ getQuestions }
				showModalAdd={ showModalAdd }
				setShowModalAdd={ setShowModalAdd }
			/>}
			<Header narrow={ false } />
			<div className={ styles['myAdvices__container'] }>
				<div className={ styles['myAdvices__buttonTop'] }>
					<Link className='button__transparent'
						to='/simple-text-advices'><div className={ `icon-arrow-left-full` } /> {dict.simpleTextAdvices.myAdvices.buttons.back}
					</Link>
				</div>
				<TopSection 
					description={ 
						<>
							{dict.simpleTextAdvices.myAdvices.description1}<br/> 
							{dict.simpleTextAdvices.myAdvices.description2}
						</> 
					}
					subTitle={ dict.simpleTextAdvices.myAdvices.subTitle }
				>
					<button className='button__blue'
						onClick={ ()=> setShowModalAdd(true) } >
						{dict.simpleTextAdvices.myAdvices.buttons.newQuestion}
					</button>
				</TopSection>
				<Tabs
					value={ tabValue }
					onChange={ handleChange }
					orientation={ isMobile ? 'vertical' : 'horizontal' }
				>
					{tabs && tabs.map(tab => 					
						<Tab
							key={ tab.id }
							value={ tab.value }
							label={ tab.label } />,
					)}
				</Tabs>
				<Pagination
					pagesNum={ pages }
					sortingOptions={ null }
					sortingValue={ null }
					sortingOnChange={ null }
					alignRight={ true }
				>
					<div>
						{questions && questions.length ? questions.map(question => <QuestionShort 
							showPublished={ true }
							key={ question.id }
							question={ question }
							myAdvices={ true } />,	
						) : <p className={ styles['myAdvices__empty'] }>{dict.simpleTextAdvices.myAdvices.empty}</p>}
					</div>
				</Pagination>
			</div>
			<Footer />
		</>
	);
};

export default SimpleTextMyAdvices;